import React, { FC, useState } from "react";

import { CSSIsolation } from "@UI/Contexts/CSSIsolation";
import {
  StaleTaskModal,
  TStaleTaskReason,
} from "@modules/ServiceRequest/Components/StaleTaskModal/StaleTaskModal";

export interface IStaleTaskModalRootProps {
  reason: TStaleTaskReason;
  seeMoreJobsUrl: string;
}

export const StaleTaskModalRoot: FC<IStaleTaskModalRootProps> = ({
  reason,
  seeMoreJobsUrl,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <CSSIsolation>
      <StaleTaskModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        reason={reason}
        seeMoreJobsUrl={seeMoreJobsUrl}
      />
    </CSSIsolation>
  );
};
